import React from 'react'
import { ContentHeader } from '../../../../../components/Header/ContentHeader'
import { IProject } from '../../../types/project'
import { RootState } from '../../../../../store/rootState'
import { connect } from 'react-redux'
import * as mainActions from '../../../../main/actions/sidebarActions'

interface StateProps {
  project: IProject
  openModal: boolean
  formOpen: boolean
  formDirty: boolean
}

interface DispatchProps {
  setOpenConfirmModal: (open: boolean) => void
  setFormOpen: (open: boolean) => void
  setFormDirty: (dirty: boolean) => void
}

type Props = StateProps & DispatchProps


const ProjectOfferHeader = (props: Props): JSX.Element => {
  const { project, formDirty, setOpenConfirmModal, setFormDirty, setFormOpen } = props

  return (
    <ContentHeader
      title={project.name}
      subtitle={project.customer ? project.customer.name : ''}
      color='#08D6A1'
      backTitle={'Budget'}
      backLocation={`/projects/${project.id}/budget`}
      formDirty={formDirty}
      setFormDirty={setFormDirty}
      setFormOpen={setFormOpen}
      setOpenConfirmModal={setOpenConfirmModal}
    />
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project,
    openModal: state.mainState.openConfirmModal,
    formOpen: state.mainState.formOpen,
    formDirty: state.mainState.formDirty,
  }
}

const mapDispatchToProps = (dispatch: mainActions.MainThunkDispatchType): DispatchProps => {
  return {
    setOpenConfirmModal: open => dispatch(mainActions.setOpenConfirmModal(open)),
    setFormOpen: open => dispatch(mainActions.setFormOpen(open)),
    setFormDirty: dirty => dispatch(mainActions.setFormDrity(dirty)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectOfferHeader)
